/**
 * @generated SignedSource<<1c7575ac524423fab3ae859e01b3854d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type assetLibraryQueriesDeleteAIAssetLibraryAssetMutation$variables = {
  id: string;
};
export type assetLibraryQueriesDeleteAIAssetLibraryAssetMutation$data = {
  readonly deleteAIAssetLibraryAsset: boolean;
};
export type assetLibraryQueriesDeleteAIAssetLibraryAssetMutation = {
  response: assetLibraryQueriesDeleteAIAssetLibraryAssetMutation$data;
  variables: assetLibraryQueriesDeleteAIAssetLibraryAssetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteAIAssetLibraryAsset",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "assetLibraryQueriesDeleteAIAssetLibraryAssetMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "assetLibraryQueriesDeleteAIAssetLibraryAssetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1e05f796e0269235eb4754fd4bb6547b",
    "id": null,
    "metadata": {},
    "name": "assetLibraryQueriesDeleteAIAssetLibraryAssetMutation",
    "operationKind": "mutation",
    "text": "mutation assetLibraryQueriesDeleteAIAssetLibraryAssetMutation(\n  $id: ID!\n) {\n  deleteAIAssetLibraryAsset(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "811739176d609b5a7d39873f932e4eba";

export default node;
